import * as PIXI from "pixi.js"
import ScaleManager from "./ScaleManager";
import Config from "../config/Config";
import { TweenMax } from "gsap";


export default class Stage {
  constructor () {
    const canvas = document.getElementById('gameCanvas')

      this.app = new PIXI.Application({
        view: canvas,
        legacy: false,
        antialias: false,
        autoDensity: false,
        preserveDrawingBuffer: true,
        sharedLoader: true,
        width: 2000,
        height: 2000,
        backgroundColor: 0x161002,
      })

      this.app.renderer.plugins.interaction.resolution = this.app.renderer.resolution = window.devicePixelRatio * 2;

      TweenMax.ticker.sleep();
      this.app.ticker.add(() => {
        TweenMax.ticker.tick();
      });

      new ScaleManager(this.app)

      window.app = this.app
      Config.app = this.app

      return this.app.stage
  }

}
